import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Bread.svg",
  "use": "Bread.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Bread.svg\"><path d=\"M52.01,33.0208v17a4,4,0,0,1-4,4h-32a4,4,0,0,1-4-4v-17a8.2771,8.2771,0,0,1,2.5265-6,8.2771,8.2771,0,0,1-2.5265-6c0-6.875,7.5-11,20-11s20,4.125,20,11a8.2771,8.2771,0,0,1-2.5265,6A8.2771,8.2771,0,0,1,52.01,33.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol